// extracted by mini-css-extract-plugin
export var deleteIcon = "_lq-5";
export var deleteOption = "_lq-3";
export var divider = "_lq-2";
export var downloadIcon = "_lq-4";
export var drawer = "_lq-0";
export var drawerFooter = "_lq-6";
export var drawerOpen = "_lq-1";
export var highlighted = "_lq-7";
export var lighterHighlight = "_lq-8";